
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 64h15.825V40.683c0-3-2.433-5.436-5.436-5.436H5.434A5.438 5.438 0 000 40.683zM24.091 64h15.825V23.83c0-3-2.433-5.436-5.434-5.436h-4.961a5.435 5.435 0 00-5.436 5.436zM53.613 0c-3 0-5.438 2.433-5.438 5.436V64H64V5.436C64 2.435 61.563 0 58.563 0z"}})])
          )
        }
      }
    